<template>
  <div>
    <auth-loader v-if="!isSessionResolved"></auth-loader>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AuthLoader from "./views/AuthLoader";

export default {
  name: "App",
  components: { AuthLoader },
  computed: {
    ...mapGetters(["isSessionResolved"]),
  },
};
</script>
